import React from 'react';
import ApiFetch from "../components/ApiFetch";

export async function isFollow(followUserId,dialog){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/follow/user/"+followUserId).then((r)=>{
        return r.json().then((json)=>{
            if(json.result){
                console.log("フォロー済みです。",followUserId)
            } else {
                dialog("エラー",json.errors)
            }
            return json.result
        })
    })
}
export async function getFollowList(userId,page,dialog){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/follow/followList/"+userId+"/"+page).then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}
export async function getFollowerList(userId,page,dialog){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/follow/followerList/"+userId+"/"+page).then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}
export async function followPost(followUserId,dialog){
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/follow/"+followUserId,{}).then((r)=>{
        return r.json().then((json)=>{
            if(json.result){
                //console.log("フォローしました。",followUserId)
            } else {
                dialog("エラー",json.errors)
            }
            return json.result
        })
    })
}
export async function followDelete(followUserId,dialog){
    return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/follow/"+followUserId,{}).then((r)=>{
        return r.json().then((json)=>{
            if(json.result){
                //console.log("フォロー解除しました。",followUserId)
            } else {
                dialog("エラー",json.errors)
            }
            return json.result
        })
    })
}


